import { render } from "./Gameboard_SidePanel_Supplier.vue?vue&type=template&id=56f82d4c"
import script from "./Gameboard_SidePanel_Supplier.vue?vue&type=script&lang=js"
export * from "./Gameboard_SidePanel_Supplier.vue?vue&type=script&lang=js"

import "./Gameboard_SidePanel_Supplier.vue?vue&type=style&index=0&id=56f82d4c&lang=scss"
script.render = render

export default script